import { fabric } from 'fabric';
import { IObjectOptions } from 'fabric/fabric-impl';
import Vec2 from 'vec2';

import {
  CANVAS_OBJECT_TYPE_PREFIX,
  DEFAULT_INTERNAL_DIAGONAL_CORNER_LENGTH,
} from '~/core/constants';
import { DiagonalCornerOptions } from '~/core/enums';
import { getRefinedEdgePoints } from '~/core/helpers';
import { CornerInfo, DrawingEdge, DrawingShape } from '~/core/models';

export const addDiagonalCornerIfNeeded = (
  shape: DrawingShape,
  edge: DrawingEdge,
  endPt: CornerInfo,
  optEdge: IObjectOptions
) => {
  // add the diagonal if needed
  optEdge.name = `${CANVAS_OBJECT_TYPE_PREFIX.DIAGONAL}_${edge.id}`;

  const diagonalPoints = getRefinedEdgePoints(
    [
      (endPt.replacementStartCoords as Vec2).x,
      (endPt.replacementStartCoords as Vec2).y,
      (endPt.replacementEndCoords as Vec2).x,
      (endPt.replacementEndCoords as Vec2).y,
    ],
    optEdge.strokeWidth
  );
  const diagObj = new fabric.Line(diagonalPoints, optEdge);

  if (
    endPt.angle < 0 &&
    endPt.diagonalLength === DEFAULT_INTERNAL_DIAGONAL_CORNER_LENGTH
  ) {
    endPt.label = DiagonalCornerOptions.INSIDE_CORNER;
  }

  shape.fabricGroup.addWithUpdate(diagObj);
};
